// extracted by mini-css-extract-plugin
export var confirmationHeader = "_x1-0";
export var confirmationIcon = "_x1-1";